import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import VueHead from 'vue-head'
import VueYoutube from 'vue-youtube'

import router from './router'
import store from './store'
import br from './lang/pt-br'

import App from './App.vue'

import './registerServiceWorker'

Vue.use(VueTheMask)

Vue.use(VeeValidate, {
  locale: 'br',
  dictionary: {
    br
  }
})

Vue.use(VueHead)

Vue.use(VueYoutube)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
